<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{label()}}</mat-label>
  
  <!-- Input Field for Manual Editing -->
  <input
    matInput
    [formControl]="control"
    (input)="onTimeChange($event)"
    placeholder="hh:mm AM"
    class="time-input"
    (focus)="openDropdown()"
    [readonly]="readOnlyPicker()"
  />

  <!-- Clear button -->
  @if(control?.value && !readOnlyPicker() && !hideClearButton()){
    <button 
      matSuffix 
      mat-icon-button 
      aria-label="Clear"
      (click)="clearTime($event)"
      class="clear-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  }

  <!-- Dropdown for Time Selection -->
  <mat-select
    (selectionChange)="onTimeChange($event)"
    class="time-dropdown"
    panelWidth="200px"
    [value]="control.value"
    #timeDropdown
  >
    <mat-select-trigger>
      <span></span>
    </mat-select-trigger>
    @for(time of timeOptions;track time){
      <mat-option [value]="time">
        {{ time }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>